/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Moment_LabelInputs */

const en_us2_today_moment_label = /** @type {(inputs: Today_Moment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last week in numbers. Open the retrospective`)
};

const pt_br2_today_moment_label = /** @type {(inputs: Today_Moment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua semana passada em números. Abrir a retrospectiva`)
};

const es_419_today_moment_label = /** @type {(inputs: Today_Moment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu semana pasada en números. Abrir la retrospectiva`)
};

const pt_pt2_today_moment_label = /** @type {(inputs: Today_Moment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua semana passada em números. Abrir a retrospetiva`)
};

const fr_fr2_today_moment_label = /** @type {(inputs: Today_Moment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta semaine dernière en chiffres. Ouvrir la rétrospective`)
};

const de_de2_today_moment_label = /** @type {(inputs: Today_Moment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine letzte Woche in Zahlen. Rückblick öffnen`)
};

const it_it2_today_moment_label = /** @type {(inputs: Today_Moment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua settimana scorsa in numeri. Apri il riepilogo`)
};

/**
* | output |
* | --- |
* | "Last week in numbers. Open the retrospective" |
*
* @param {Today_Moment_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_moment_label = /** @type {((inputs?: Today_Moment_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Moment_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_moment_label(inputs)
	if (locale === "es-419") return es_419_today_moment_label(inputs)
	if (locale === "pt-PT") return pt_pt2_today_moment_label(inputs)
	if (locale === "fr-FR") return fr_fr2_today_moment_label(inputs)
	if (locale === "de-DE") return de_de2_today_moment_label(inputs)
	if (locale === "it-IT") return it_it2_today_moment_label(inputs)
	return en_us2_today_moment_label(inputs)
});
export { today_moment_label as "today.moment_label" }